import { WIDGET_CONTAINER_MAX_HEIGHT } from '@/ui/widget/widget';

const WIDGET_BOTTOM_CONTENT_GAP = 12;

export function getListMaxHeight(
  listElement: HTMLElement,
  maxHeightOffset = 0,
): number {
  const container = listElement.offsetParent;
  const widgetBottomHeight = (
    container?.querySelector(
      '[data-name="widget-bottom-content"]',
    ) as HTMLElement | null
  )?.offsetHeight;
  const containerPaddingBottom = container
    ? parseFloat(getComputedStyle(container).paddingBottom) || 0
    : 0;

  return Math.max(
    0,
    WIDGET_CONTAINER_MAX_HEIGHT -
      listElement.offsetTop -
      containerPaddingBottom -
      (widgetBottomHeight
        ? widgetBottomHeight + WIDGET_BOTTOM_CONTENT_GAP
        : 0) -
      maxHeightOffset,
  );
}

export function toMaxHeightStyle(
  maxHeight: number | null | undefined,
): string | undefined {
  if (maxHeight === null || maxHeight === undefined) return undefined;
  return maxHeight > 0 ? `${maxHeight}px` : 'none';
}

export function observeListMaxHeight(
  listElement: HTMLElement,
  onChange: () => void,
): () => void {
  let observedContainer: Element | null = null;

  const observer = new ResizeObserver(() => {
    syncContainer();
    onChange();
  });

  const syncContainer = () => {
    const container = listElement.offsetParent;
    if (container === observedContainer) return;

    if (observedContainer) observer.unobserve(observedContainer);
    if (container) observer.observe(container);
    observedContainer = container;
  };

  observer.observe(listElement);
  syncContainer();

  return () => observer.disconnect();
}
